import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core'
import {BsModalRef} from "ngx-bootstrap/modal";
import {PERMISSION, SingleResponse} from "@generated-backend-types";
import {Observable, of, switchMap, throwError} from "rxjs";
import {ToastrService} from "ngx-toastr";
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {NGXLogger} from "ngx-logger";
import {NotEnoughPermissionsError} from '../../errors/NotEnoughPermissionsError';
import {UserSessionService} from '../../services/user-session.service';

@Component({
  selector: 'app-confirm-delete-modal',
  templateUrl: './confirm-delete-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslatePipe
  ],
  standalone: true
})
export class ConfirmDeleteModalComponent<T = void> {
  public modelId?: string;
  public observable?: Observable<SingleResponse<T>> | Observable<void>;
  public dialogTranslation?: string;
  public successTranslation?: string;
  public errorTranslation?: string;
  public actionButtonTranslation: string = 'misc.delete_btn';
  public permissions?: PERMISSION[];

  @Output() deleteSuccess: EventEmitter<void> = new EventEmitter();
  @Output() deleteError: EventEmitter<void> = new EventEmitter<void>();


  public delete(): void {
    if(this.modelId && this.observable) {
      of(this.modelId).pipe(
        switchMap(() => {
          if (!this.userSessionService.hasAllPermission(this.permissions ?? [])) {
            return throwError(() => new NotEnoughPermissionsError());
          }
          return this.observable!;
        })
      ).subscribe({
        next: () => {
          this.toastrService.success(this.translate.instant(this.successTranslation ?? ''));
          this.deleteSuccess.next();
          this.bsModalRef.hide();
        },
        error: err => {
          if (err instanceof NotEnoughPermissionsError) {
            this.toastrService.error(this.translate.instant('misc.not_enough_permissions_error'));
          } else {
            this.log.error(JSON.stringify(err));
            this.toastrService.error(this.translate.instant(this.errorTranslation ?? ''));
          }
          this.deleteError.next();
          this.bsModalRef.hide();
        }
      });
    } else {
      this.deleteSuccess.next();
      this.bsModalRef.hide();
    }
  }

  public constructor (
    private readonly userSessionService: UserSessionService,
    private readonly toastrService: ToastrService,
    private readonly translate: TranslateService,
    private readonly log: NGXLogger,
    public bsModalRef: BsModalRef,
  ) {}
}
